import { ThemeBase } from "../ThemeBase";
import alteGoLogoTemplate from "./template/altego-logo-template";
import styleSheet from "./styles/altego-theme.css?inline";

/**
 * alte-GO
 * ---
 * White label brand of ALTEO, the Hungarian energy group - "alte-GO, powered by ALTEO" is its
 * e-mobility arm. Palette and typography come from the ALTEO Brand Identity Guidelines 2025.
 *
 * Lexend is the brand's primary typeface and is served from the Google Fonts host index.html
 * already preconnects to for Roboto, so there is no font to ship with the theme.
 */
export class AlteGoTheme extends ThemeBase {
	static themeID = "altego";

	/**
	 * @override
	 * Bamboo Green, the brand's primary colour.
	 */
	get primaryColor() {
		return "#6ba43a";
	}

	/**
	 * @override
	 */
	get backgroundColor() {
		return "#f5f6f6";
	}

	/**
	 * @override
	 */
	get styleSheet() {
		return styleSheet;
	}

	/**
	 * @override
	 */
	get fontStyleSheets() {
		return ["https://fonts.googleapis.com/css2?family=Lexend:wght@300..700&display=swap"];
	}

	/**
	 * @override
	 * The lockup is wide and carries the small "POWERED BY ALTEO" line above the wordmark, so it
	 * needs a little more height than a bare wordmark would.
	 */
	get logoForMenu() {
		return this.getLogo(`style="width: 100%; height: 52px"`);
	}

	/**
	 * @override
	 */
	get logoForLoader() {
		return this.getLogo();
	}

	/**
	 * @override
	 */
	get chargingAnimationUrl() {
		return "/themes/altego/assets/images/active.svg";
	}

	/**
	 * @override
	 */
	getLogo(attributes = '') {
		return alteGoLogoTemplate(attributes);
	}
}

new AlteGoTheme();
